<template lang="pug">
v-main
  v-container(fluid)
    v-flex
      v-card
        v-toolbar.elevation-0(color="white")
          v-toolbar-title(v-model="title") {{ title }}
        v-divider
        v-toolbar.elevation-0.mt-2.mb-4(color="white")
          v-select.hidden-sm-and-down.col-3.pl-0(
            label="Business Unit",
            v-model="buid",
            :items="dataBusinessUnit",
            hide-details
          )
          span.pr-2
          v-select.hidden-sm-and-down.col-3.pl-0(
            label="Choose Activity",
            v-model="activity",
            :items="dataActivity",
            hide-details
          )
          span.pr-2
          v-menu.col-3(
            ref="menu",
            v-model="menu",
            :close-on-content-click="false",
            :return-value.sync="date",
            transition="scale-transition",
            offset-y,
            min-width="auto"
          )
            template(v-slot:activator="{ on, attrs }")
              v-text-field.mb-3(
                v-model="dateRange",
                label="Date Range",
                prepend-inner-icon="date_range",
                readonly,
                v-bind="attrs",
                v-on="on",
                hide-details,
                flat
              )
            v-date-picker(v-model="date", range)
              v-spacer
              v-btn(text, color="primary", @click="menu = false") Cancel
              v-btn(text, color="primary", @click="chooseDate") OK
          span.pr-2
          v-text-field.hidden-sm-and-down.col-3(
            flat,
            append-icon="search",
            placeholder="Keyword (optional)",
            v-model="keyword",
            hide-details
          )
        v-divider
        v-card-text.pa-0
          v-dialog(v-model="dialog" width="80%" persistent )
            template(v-slot:activator="{ on, attrs }")
            v-card
              v-card-title
                span(class="text-h5" style="font-weight:bold; margin:0.5rem") {{ LogDetailTitle }}
                div(v-if="dualViewLog" style='width: 100%;display: flex; border: 1px solid #DDD; background: #DDD')
                  h4(style="flex:1;margin:.2rem 0 .2rem 1rem") Before
                  h4(style="flex:1;margin:.2rem 0 .2rem ") After
                div(v-if="dualViewLog" style='width: 100%;display: flex; ')
                  pre(
                    id="jsonCode1"
                    style=" border: 1px #DDD solid; overflow: auto; height: 50vh; width: 100%;"
                  ) 
                  pre(
                    id="jsonCode2"
                    style=" border: 1px #DDD solid; overflow: auto; height: 50vh; width: 100%;"
                  )
                div(v-if="!dualViewLog" style='width: 100%;')
                  pre(
                    id="jsonCode3"
                    style=" border: 1px #DDD solid; overflow: auto; height: 70vh; width: 100%;"
                  ) 
              v-card-actions
                v-spacer
                div(style="flex-direction: row-reverse;width: 100%;display: flex;justify-content: space-between;margin: 0 1rem;")
                  v-btn(
                    large
                    color="primary"
                    @click="dialog = false; dualViewLog = false"
                  ) Close

                  p(v-if="dualViewLog" style="color:#000") 
                    span(style="color:#2196F3") *
                    | &nbsp;Blue letter marks indicate data updates.
                
          v-data-table(
            
            :server-items-length="totalLog"
            :loading="loading"
            :headers="dataHeaders",
            :items="dataItems",
            :search="keyword"
            :options.sync="options"
          )
            template(v-slot:item.action="{ item }")
              v-icon(style="color:#2196f3" small class="mr-2" @click="deetailItem(item)") remove_red_eye
</template>
<script>
import axios from "axios";
export default {
  props: {
    title: String,
  },
  data() {
    return {
      dualViewLog: false,
      totalLog: 10,
      LogDetailTitle: ``,
      loading: false,
      detailTextJson: ``,
      dialog: false,
      keyword: ``,
      activity: "",
      buid: "",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateRange: `${new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)} ~ ${new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)}`,
      dataHeaders: [
        { text: "Name", value: "name" },
        { text: "Date Time", value: "date" },
        { text: "Activity", value: "activity" },
        { text: "Data", value: "data" },
        { text: "Detail", value: "action", sortable: false },
      ],
      dataBusinessUnit: [
        {text: "All", value: "" },
      ],
      dataItems: [],
      menu: false,
      perPage: 10,
      page: 1,
      options: {
        sortBy: ["date"],
        sortDesc: [true],
      },
      InitialOptions: {
        sortBy: ["date"],
        sortDesc: [true],
      },
    };
  },
  computed: {
    dataActivity() {
      if (JSON.parse(localStorage.getItem("user")).is_super_admin) return [
        {text: "All", value: "" },
        {text:"Edit User Profile", value:"Edit User Profile"},
        {text:"Edit User BU Profile", value:"Edit User BU Profile"},
        {text:"Create Super Admin", value:"Create Super Admin"},
        {text:"Create Admin", value:"Create Admin"},
        {text:"Create User", value:"Create User"},
        {text:"Add BU to Existing User", value:"To Existing User"},
        {text:"Create Business Unit", value:"Create Business Unit"},
        {text:"Edit Business Unit", value:"Edit Business Unit"},
        {text:"Edit Business Unit Setting", value:"Edit Business Unit Setting"},
        {text:"Create CMS BANK", value:"Create CMS BANK"},
        {text:"Edit CMS BANK", value:"Edit CMS BANK"},
        {text:"Delete CMS BANK", value:"Delete CMS BANK"},
        {text:"Create Blocked Email", value:"Create Blocked Email"},
        {text:"Edit Blocked Email", value:"Edit Blocked Email"},
      ]
      return [
        {text: "All", value: "" },
        {text:"Edit User BU Profile", value:"Edit User BU Profile"},
        {text:"Create Admin", value:"Create Admin"},
        {text:"Create User", value:"Create User"},
        {text:"Add BU to Existing User", value:"To Existing User"},
        {text:"Edit Business Unit", value:"Edit Business Unit"},
        {text:"Edit Business Unit Setting", value:"Edit Business Unit Setting"}
      ]
    
    }
  },
  methods: {
    getTanggal(tgl) {
      //- let monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
      let tanggal = new Date(tgl);
      //- let month = tanggal.getMonth();
      let date = tanggal.getDate() < 10 ? '0'+tanggal.getDate() : tanggal.getDate();
      const month = tanggal.toLocaleString('default', { month: 'short' });
      let hour = tanggal.getHours() < 10 ? '0'+tanggal.getHours() : tanggal.getHours();
      let minutes = tanggal.getMinutes() < 10 ? '0'+tanggal.getMinutes() : tanggal.getMinutes();
      let second = tanggal.getSeconds() < 10 ? '0'+tanggal.getSeconds() : tanggal.getSeconds();
      return date+' '+month+' '+tanggal.getFullYear()+' '+hour+':'+minutes+':'+ second;
    },
    deetailItem(item){
      this.editedItem = Object.assign({}, item);
      item.detail = typeof item.detail === "string"? JSON.parse(item.detail) : item.detail
      this.LogDetailTitle = item.activity
      if (item.alter && item.diff.length != 0 && item.before) {
        this.dialog = true;
        this.dualViewLog = true

        const highlightLine = function (jsonString, searchFor) {
          const regex = new RegExp('(.*' + searchFor + '.*)', 'g');
          const highlighted = '<span class="highlighted">$1</span>';
          const newJsonString = jsonString.replace(regex, highlighted);
          return newJsonString;
        };

        let isShowEditBuSetting = false

        if (item.before.includes("themeColors", "footerEmailWhatsApp")) isShowEditBuSetting =true

        item.beforeR = JSON.stringify(JSON.parse(item.before), undefined, 4)
        item.detailR = JSON.stringify(item.detail, undefined, 4)

        for (let i in item.diff ) {

          if (isShowEditBuSetting) {
            item.beforeR = highlightLine(item.beforeR.replace(/\\/g, ''), item.diff[i].replace(/\\/g, ''))
            item.detailR = highlightLine(item.detailR.replace(/\\/g, ''), item.diff[i].replace(/\\/g, ''))
          } else {
            item.beforeR = highlightLine(item.beforeR, item.diff[i])
            item.detailR = highlightLine(item.detailR, item.diff[i])
          }
          
        }

        setTimeout(()=> {

          if (isShowEditBuSetting) {
            document.getElementById('jsonCode2').innerHTML = item.detailR.replace(/\\/g, '')
            document.getElementById('jsonCode1').innerHTML = item.beforeR.replace(/\\/g, '')
          } else {
            document.getElementById('jsonCode2').innerHTML = item.detailR
            document.getElementById('jsonCode1').innerHTML = item.beforeR
          }
          
        },20)
      } else {
        setTimeout(()=> {
          document.getElementById('jsonCode3').innerHTML  = JSON.stringify(item.detail, null, 2)
        }, 50)
        this.dialog = true;
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    chooseDate() {
      if (typeof this.date === "string" ||  this.date.length === 1) this.date = [this.date, this.date];
      if (this.date[0] < this.date[1])
        this.dateRange = `${this.date[0]} ~ ${this.date[1]}`;
      else if (this.date[0] > this.date[1])
        this.dateRange = `${this.date[1]} ~ ${this.date[0]}`;
      else this.dateRange = `${this.date[0]} ~ ${this.date[1]}`;
      this.menu = false;
    },
    fecthLog() {
      let sortBy = this.options.sortBy[0]
      if (sortBy == "name") sortBy = "user.full_name"
      if (sortBy == "date") sortBy = "updated_at"
      // if ( this.options.page == undefined ) this.options.page = 1
      // if ( this.options.rowsPerPage == undefined ) this.options.rowsPerPage = this.perPage
      const direction = this.options.sortDesc[0] ? -1 : 1;
      const token = localStorage.getItem("token");
      const axiosConfig = {
        method: "GET",
        url: process.env.VUE_APP_API + `/users/logs/?buId=${this.buid}&activity=${this.activity}&dateFrom=${this.dateRange.split("~")[0].trim()}T00:00:00.000Z&dateTo=${this.dateRange.split("~")[1].trim()}T23:59:59.000Z&keyword=${this.keyword}&sortBy=${sortBy}&direction=${direction}&page=${this.page}&perPage=${this.perPage}`,
        headers: {"Authorization": `Bearer ${token}`},
      }
      axios(axiosConfig)
      .then(({data}) => {
        let result = []
        this.totalLog = data.total
        const logData = data.data
        
        for (let i in logData) {
          try {
            result.push({
              name: logData[i].user? logData[i].user.full_name : "-",
              date: this.getTanggal(logData[i].updated_at),
              activity: logData[i].activity,
              data: `${logData[i].data.substr(0, 10)}...`,
              detail: logData[i].data,
              before: logData[i].before ? logData[i].before : logData[i].data,
              alter: logData[i].alter ? logData[i].alter : false,
              diff: logData[i].diff ? logData[i].diff : [],
            })
          } catch (error) {}
        }
        this.dataItems = result
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      });
    },
    fetchBUData() {
      if (JSON.parse(localStorage.getItem("user")).is_super_admin) {
        const token = localStorage.getItem("token");
        const axiosConfig = {
          method: "GET",
          url: process.env.VUE_APP_API + `/business-unit/list`,
          headers: {"Authorization": `Bearer ${token}`},
        }
        axios(axiosConfig)
        .then((result) => {
          const data = result.data.data
          for (let i in data ) this.dataBusinessUnit.push({text: data[i].bu_name, value: data[i].id })
        })
      } else {
        const token = localStorage.getItem("token");
        axios.get(process.env.VUE_APP_API + `/users/info`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((result) => {
          const data = result.data.data.user.bu
          for (let i in data ) if (data[i].is_admin) this.dataBusinessUnit.push({text: data[i].business_unit.bu_name, value: data[i].business_unit.id })
        })
      }
    }
  },
  watch: {
    // options(val){
    //     this.itemsPerPage = val.itemsPerPage
    //     this.getOptions()
    // },
    options(val) {
      // alert(`${JSON.stringify(val)} \n\n\n\n ${JSON.stringify(this.options)}`)
      if (val.sortBy.length && val.sortDesc.length) {
        this.options.sortBy = val.sortBy
        this.options.sortDesc = val.sortDesc
        this.InitialOptions.sortBy = val.sortBy
        this.InitialOptions.sortDesc = val.sortDesc
      } else {
        // alert("MASUKK ELSEEE")
        // alert(JSON.stringify(this.InitialOptions))
        this.options.sortBy = this.InitialOptions.sortBy
        this.options.sortDesc = [!this.InitialOptions.sortDesc]
        // alert(JSON.stringify(this.options))
      }
      this.perPage = val.itemsPerPage;
      // this.options.page = 1
      this.page = val.page;
      
      this.fecthLog();
    },
    keyword() {
      if (this.keyword.length >= 3) this.fecthLog();
    },

    activity() {
      this.options.page = 1
      this.page = 1;
      this.fecthLog();
    },
    buid() {
      // alert("BUID CHANGED")
      this.options.page = 1
      this.page = 1;
      this.fecthLog();
    },
    dateRange() {
      this.options.page = 1
      this.page = 1;
      this.fecthLog();
    },
  },
  mounted() {
    this.fetchBUData()
    this.fecthLog()
  },
};
</script>

<style>
.highlighted {
      color: #2196F3;
    }
</style>